const colors = {
  red: '#c1272d',
  lightRed: '#c1272d26',
  yellow: '#f9b200',
  golden: '#bc8813',
  purple: '#72354e',
  lightYellow: '#fef0cc',
  confirmGreen: '#23c48a',
  lightGreen: '#23c38b1d',
  orange: '#f27606',
  lightOrange: '#f2760638',
  blue: '#1976d2',
  lightBlue: '#1976d21d',
  black: '#000000',
  grey: '#9e9e9e',
  cardGrey: '#faf9f9',
  columnGrey: '#f8f8f8',
  white: '#fff',
  semPararPink: '#d60b52',
  semPararGrey: '#505050',
  sempararBackground: '#f9f9f9',
  cargillGreen: '#00843D',
  cargillLightGreen: '#F5F9ED',
};

const torqiPalette = {
  primary: colors.black,
  secondary: colors.red,
  lightSecondary: colors.lightRed,
  yellow: colors.yellow,
  lightYellow: colors.lightYellow,
  green: colors.confirmGreen,
  lightGreen: colors.lightGreen,
  orange: colors.orange,
  lightOrange: colors.lightOrange,
  error: colors.red,
  blue: colors.blue,
  lightBlue: colors.lightBlue,
  black: colors.black,
  grey: colors.grey,
  cardGrey: colors.cardGrey,
  columnGrey: colors.columnGrey,
  white: colors.white,
  purple: colors.purple,
  golden: colors.golden,
  sidebarBackground: colors.black,
  sidebarTextColor: colors.white,
  sidebarIconColor: colors.white,
  sidebarHoverBg: 'rgba(255, 255, 255, 0.05)',
  sidebarSelectedBg: 'rgba(255, 255, 255, 0.1)',
  sidebarSelectedTextColor: colors.white,
};

const semPararPalette = {
  primary: colors.semPararGrey,
  secondary: colors.semPararPink,
  lightSecondary: colors.lightRed,
  yellow: colors.yellow,
  lightYellow: colors.lightYellow,
  green: colors.confirmGreen,
  lightGreen: colors.lightGreen,
  orange: colors.orange,
  lightOrange: colors.lightOrange,
  error: colors.red,
  blue: colors.blue,
  lightBlue: colors.lightBlue,
  black: colors.black,
  grey: colors.semPararGrey,
  cardGrey: colors.cardGrey,
  columnGrey: colors.columnGrey,
  white: colors.sempararBackground,
  purple: colors.purple,
  golden: colors.golden,
  sidebarBackground: colors.white,
  sidebarTextColor: colors.black,
  sidebarIconColor: colors.semPararPink,
  sidebarHoverBg: colors.sempararBackground,
  sidebarSelectedBg: 'rgba(255, 255, 255, 0.1)',
  sidebarSelectedTextColor: colors.semPararPink,
};

const cargillPalette = {
  primary: colors.cargillGreen,
  secondary: colors.cargillGreen,
  lightSecondary: colors.cargillLightGreen,
  yellow: colors.yellow,
  lightYellow: colors.lightYellow,
  green: colors.confirmGreen,
  lightGreen: colors.lightGreen,
  orange: colors.orange,
  lightOrange: colors.lightOrange,
  error: colors.red,
  blue: colors.blue,
  lightBlue: colors.lightBlue,
  black: colors.black,
  grey: colors.grey,
  cardGrey: colors.cargillLightGreen,
  columnGrey: colors.cargillLightGreen,
  white: colors.white,
  purple: colors.purple,
  golden: colors.golden,
  sidebarBackground: colors.cargillLightGreen,
  sidebarTextColor: colors.black,
  sidebarIconColor: colors.black,
  sidebarHoverBg: 'rgba(0, 132, 61, 0.08)',
  sidebarSelectedBg: colors.cargillGreen,
  sidebarSelectedTextColor: colors.white,
};

export { colors, torqiPalette, semPararPalette, cargillPalette };
